import { InvoiceIncomingItemsAllocationState } from "../InvoiceIncomingItemsAllocation/types";

export const INITIAL_ALLOCATION_STATE: InvoiceIncomingItemsAllocationState = {
  allocated: 0,
  total: 0,
  isSaving: false,
  hasErrors: false,
};
